module.exports = __webpack_public_path__ + "img/b-1.97d7eef8.gif";